import {GET_ALL_TASKS_EXECUTIVE_DASHBOARD} from '../../../actions/actiontypes';

export default function tasksViewReducer(state = {}, action) {
	switch (action.type) {
		case GET_ALL_TASKS_EXECUTIVE_DASHBOARD: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			allTasks.apiLoaded = true;
			return {...allTasks, quickFilterId: action.quickFilterId};
		}
		default:
			return state;
	}
}
